import { PATH, PAYMENT_STATUS, STORAGE_KEY } from '@/constants';
import { API_ENDPOINTS } from '@/constants/api-endpoints';
import { apiInstance, handleShowError } from '@/utils';
import { clearAuthLocalStorage } from '@/utils/durableLocalStorage';
import { toast } from 'react-toastify';
import { getAskIotUserDetails } from './user';

export const logout = async () => {
  try {
    const response = await fetch(API_ENDPOINTS.LOGOUT, {
      method: 'POST',
    });
    if (!response.ok) {
      handleShowError(new Error('Server sign-out failed'));
    }
  } catch (error) {
    // Local sign-out must remain available during an API/network outage. The
    // server cookie will expire independently; clearing the browser auth state
    // prevents the user from remaining trapped in a protected route.
    handleShowError(error);
  } finally {
    if (typeof window !== 'undefined') {
      clearAuthLocalStorage();
      window.location.href = PATH.LOGIN;
    }
  }
};

interface EmailValidationResponse {
  valid: boolean;
  userExists?: boolean;
  error?: string;
  status?: string;
  sub_status?: string;
  validationStatus?: string;
  validationSubStatus?: string;
  address?: string;
  free_email?: boolean;
  did_you_mean?: string | null;
  domain?: string;
  message?: string;
}

export const validateEmail = async (email: string): Promise<EmailValidationResponse> => {

  try {
    const res = await apiInstance({
      method: 'POST',
      url: API_ENDPOINTS.validateEmail,
      data: {
        email,
      },
    });

    return res.data;
  } catch (error: any) {

    // Handle 409 status (user already exists) as a special case
    // Check both error.status and error.response.status for different axios versions
    const status = error.status || error.response?.status;
    const responseData = error.data || error.response?.data;

    if (status === 409) {
      const result: EmailValidationResponse = {
        valid: false,
        userExists: true,
        error: responseData?.error || 'User already exists',
        ...responseData
      };
      return result;
    }

    // Re-throw other errors to be handled by onError
    throw error;
  }
};

export const validateUserAccess = async (
  accessToken: string,
): Promise<{ accessible: boolean } | undefined> => {
  // Legacy access checks removed. Now always returns accessible: true if accessToken is present.
  if (accessToken) {
    return { accessible: true };
  }
  return { accessible: false };
};
